import { HttpService } from './http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NGXLogger } from "ngx-logger";
import { homeDetails, visualQueueTimeline } from 'src/app/home/models/home-models';

@Injectable({
  providedIn: 'root'
})

export class HomeService {

  constructor(private http: HttpService, private logger: NGXLogger) { }

  public getHomePage(): Observable<homeDetails> {
    return this.http.getFromApi(`/Home`);
  }

  public getAvailableQueueMonitorData(qIds: string): Observable<any> {
    return this.http.postToApi(`/Home/GetAvailableQueueMonitorData`, JSON.stringify(qIds));
  }

  public getVisualQueueTimeline(model: visualQueueTimeline): Observable<any> {
    return this.http.postToApi(`/Home/GetVisualQueueTimeline`, JSON.stringify(model));
  }
}   